import { createReducer, on } from '@ngrx/store';
import { ReplyTemplateActions } from '@actions/index'
import { ReplyTemplateModel } from '@models/index'


export interface State {
    replyTemplate: ReplyTemplateModel

}

const initialState: State = {
    replyTemplate: {
        reply: ""
    }
};

export const reducer = createReducer(
    initialState,
    on(ReplyTemplateActions.getReplyTemplateSuccess, (state, { response }) => ({ ...state, replyTemplate: response })),
    on(ReplyTemplateActions.saveReplyTemplateSuccess, (state, { response }) => ({ ...state, replyTemplate: response })),
    on(ReplyTemplateActions.setReplyTemplate, (state, { text }) => ({
        ...state,
        replyTemplate: { ...state.replyTemplate, reply: text }
    })),
)


export const getReplyTemplate = (state: State) => state.replyTemplate;
